'use client';

import React from "react";
import PropTypes from 'prop-types';

import Markdown from "src/components/markdown";

function RecipeShortDescription({recipeData}) {
  if (!recipeData.description) {
    return '';
  }

  return (
    <Markdown children={recipeData.description} />
  );
}

RecipeShortDescription.propTypes = {
  recipeData: PropTypes.object
}

export default RecipeShortDescription;
